<template>
  <router-view></router-view>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  methods: {
    ...mapActions(['api_get_login_user']),
  },
  mounted() {
    // this.api_get_login_user();
  },
};
</script>
<style>
.mtd-col-pull-0,
.mtd-col-pull-1,
.mtd-col-pull-10,
.mtd-col-pull-11,
.mtd-col-pull-12,
.mtd-col-pull-13,
.mtd-col-pull-14,
.mtd-col-pull-15,
.mtd-col-pull-16,
.mtd-col-pull-17,
.mtd-col-pull-18,
.mtd-col-pull-19,
.mtd-col-pull-2,
.mtd-col-pull-20,
.mtd-col-pull-21,
.mtd-col-pull-22,
.mtd-col-pull-23,
.mtd-col-pull-24,
.mtd-col-pull-3,
.mtd-col-pull-4,
.mtd-col-pull-5,
.mtd-col-pull-6,
.mtd-col-pull-7,
.mtd-col-pull-8,
.mtd-col-pull-9,
.mtd-col-push-0,
.mtd-col-push-1,
.mtd-col-push-10,
.mtd-col-push-11,
.mtd-col-push-12,
.mtd-col-push-13,
.mtd-col-push-14,
.mtd-col-push-15,
.mtd-col-push-16,
.mtd-col-push-17,
.mtd-col-push-18,
.mtd-col-push-19,
.mtd-col-push-2,
.mtd-col-push-20,
.mtd-col-push-21,
.mtd-col-push-22,
.mtd-col-push-23,
.mtd-col-push-24,
.mtd-col-push-3,
.mtd-col-push-4,
.mtd-col-push-5,
.mtd-col-push-6,
.mtd-col-push-7,
.mtd-col-push-8,
.mtd-col-push-9,
.mtd-rate-item,
.mtd-row {
  position: relative;
}
</style>
